import React, { useState } from "react";
import styles from "./sidebar.module.css";
import { Icon } from "@iconify/react";
const Sidebar = ({
  data,
  toLocate,
  eventCategories,
  eventCategoriesHandler,
  eventId,
}) => {
  const [search, setSearch] = useState("");

  const dataa = data.filter((e) => {
    if (search == "") {
      return data;
    }
    return e.title.toLowerCase().includes(search);
  });

  let $i = 0;
  const dataCard = dataa.map((data) => {
    if ($i == 3) {
      return;
    }
    $i++;
    return <Card data={data} toLocate={toLocate} key={Math.random()} />;
  });
  console.log(eventId);
  return (
    <div className={styles.sidebar}>
      <div className={styles.headerInfo}>
        <p>
          {" "}
          <a href="mailto:harismaulanaikhsan40@gmail.com">
            Haris Maulana Ikhsan
          </a>
        </p>

        <a href="https://github.com/HarisMI40">
          <Icon icon="bi:github" />
        </a>

        <a href="mailto:harismaulanaikhsan40@gmail.com">
          <Icon icon="carbon:email" />
        </a>
      </div>

      <div className={styles.container}>
        <div className={styles.search}>
          <input
            type="text"
            placeholder="Search"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </div>

        <ul>
          {eventCategories.map((e) => {
            return (
              <li
                className={eventId == e.id ? styles.active : ""}
                onClick={() => eventCategoriesHandler(e.id, e.icon, e.color)}
              >
                <Icon icon={e.icon} />
                {e.events}
              </li>
            );
          })}
        </ul>
        <p className={styles.listOfText}>list of Natural Events</p>
        <span className={styles.totalData}>Total : {data.length}</span>
        <hr></hr>
        <div className={styles.main}>{dataCard}</div>
      </div>
    </div>
  );
};

const Card = ({ data, toLocate }) => {
  const title = data.title;
  const cropTitle = title.substring(0, 20) + "...";
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h3 className={styles.title}>{title}</h3>
      </div>
      <div className={styles.body}>
        <p>
          Detail :{" "}
          <a href={data.link} target="_blank">
            link
          </a>
        </p>
        <p>
          Location :{" "}
          <span className={styles.location}>{`${data.lat}, ${data.lng}`}</span>
        </p>
      </div>
    </div>
  );
};

export default Sidebar;
